import { render, staticRenderFns } from "./DeviceView.vue?vue&type=template&id=97808f3a&"
import script from "./DeviceView.vue?vue&type=script&lang=ts&"
export * from "./DeviceView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports